import React from 'react';
import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProduct } from '../../../helpers/getBaseProduct';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import { Caption } from '../../Common/Caption';
import { Selector, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  chainColour: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (chainColour, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      chainColour,
    },
  });

export const ChainColour = () => {
  const [state, send] = useService(productBuilderMachine);
  const baseProduct = getBaseProduct(state.context);
  const chainColourOptions = baseProduct
    ? baseProduct.metafields.chain_colour || []
    : [];
  const {
    custom: { chainColour },
  } = state.context;

  if (isCurrentState('chainColour', state) && chainColourOptions.length === 0) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Chain colour</Heading>
      <Caption>Chain colour</Caption>
      <Selector>
        {chainColourOptions.map(option => {
          return (
            <SelectorItem
              isSelected={option === chainColour}
              onClick={onClick(option, send)}
              key={option}
            >
              {option}
            </SelectorItem>
          );
        })}
      </Selector>
    </SectionContent>
  );
};
